import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_4755f2b4 from 'nuxt_plugin_plugin_4755f2b4' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_2998be80 from 'nuxt_plugin_sentryserver_2998be80' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_78416610 from 'nuxt_plugin_sentryclient_78416610' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_recaptcha_24584b2b from 'nuxt_plugin_recaptcha_24584b2b' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_22f7bb38 from 'nuxt_plugin_cookieuniversalnuxt_22f7bb38' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_gtm_c6507edc from 'nuxt_plugin_gtm_c6507edc' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_moment_70c92348 from 'nuxt_plugin_moment_70c92348' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_pluginutils_28e77a02 from 'nuxt_plugin_pluginutils_28e77a02' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_20efe6ec from 'nuxt_plugin_pluginrouting_20efe6ec' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_483d3b25 from 'nuxt_plugin_pluginmain_483d3b25' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_nuxtplugintemplate70eaf4f2_7d491f3f from 'nuxt_plugin_nuxtplugintemplate70eaf4f2_7d491f3f' // Source: ./nuxt.plugin.template.70eaf4f2.js (mode: 'all')
import nuxt_plugin_axios_26ff7abc from 'nuxt_plugin_axios_26ff7abc' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_deviceplugin_4bbe9647 from 'nuxt_plugin_deviceplugin_4bbe9647' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_repositories_3f2ec844 from 'nuxt_plugin_repositories_3f2ec844' // Source: ../plugins/repositories (mode: 'all')
import nuxt_plugin_axios_5659cf26 from 'nuxt_plugin_axios_5659cf26' // Source: ../plugins/axios.ts (mode: 'all')
import nuxt_plugin_header_bb303ad4 from 'nuxt_plugin_header_bb303ad4' // Source: ../plugins/header.client (mode: 'client')
import nuxt_plugin_axiosclient_978c8458 from 'nuxt_plugin_axiosclient_978c8458' // Source: ../plugins/axios.client.ts (mode: 'client')
import nuxt_plugin_veevalidate_6e5ad03a from 'nuxt_plugin_veevalidate_6e5ad03a' // Source: ../plugins/vee-validate (mode: 'all')
import nuxt_plugin_notification_f433b93e from 'nuxt_plugin_notification_f433b93e' // Source: ../plugins/notification (mode: 'all')
import nuxt_plugin_focusoutside_1eaac9fa from 'nuxt_plugin_focusoutside_1eaac9fa' // Source: ../plugins/focus-outside (mode: 'all')
import nuxt_plugin_api_5e4622e4 from 'nuxt_plugin_api_5e4622e4' // Source: ../plugins/api (mode: 'all')
import nuxt_plugin_jwt_58cb8274 from 'nuxt_plugin_jwt_58cb8274' // Source: ../plugins/jwt.js (mode: 'all')
import nuxt_plugin_floatingvue_098517bc from 'nuxt_plugin_floatingvue_098517bc' // Source: ../plugins/floating-vue.js (mode: 'client')
import nuxt_plugin_portalvue_cb5f1eca from 'nuxt_plugin_portalvue_cb5f1eca' // Source: ../plugins/portal-vue (mode: 'client')
import nuxt_plugin_plyr_6a84fe8b from 'nuxt_plugin_plyr_6a84fe8b' // Source: ../plugins/plyr (mode: 'client')
import nuxt_plugin_autoleadclient_10a070c2 from 'nuxt_plugin_autoleadclient_10a070c2' // Source: ../plugins/autolead.client.js (mode: 'client')
import nuxt_plugin_auth_7a283218 from 'nuxt_plugin_auth_7a283218' // Source: ./auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"GeekBrains - образовательный портал","htmlAttrs":{"lang":"ru"},"meta":[{"charset":"UTF-8"},{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"http-equiv":"Content-Type","content":"text\u002Fhtml; charset=UTF-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Мы учим людей с нуля осваивать программирование, веб-дизайн и маркетинг и другие профессии. Проводим онлайн-курсы и бесплатные мастер-классы, развиваем сообщество, сотрудничаем с компаниями по трудоустройству и непрерывно тестируем новые методики для поднятия эффективности обучения."},{"name":"yandex-verification","content":"e3eca60199b3f188"},{"name":"wot-verification","content":"6c2e6aa2d0f236811c4b"},{"name":"yandex-verification","content":"79fe41f8160bace9"},{"name":"google-site-verification","content":"lAoRtxDloe2PQ5D6AzHYmWg20Gw1r-bvCCw1EFW36gM"},{"name":"google-site-verification","content":"zpu_CX6-uHzQEsu1LHk-EXX-Tdd8ubvz1fechBWxRhc"},{"name":"facebook-domain-verification","content":"2s0fakksur3vrzykkmn8zt58rrdbd6"},{"name":"og:site_name","content":"GeekBrains"},{"hid":"og:title","property":"og:title","content":"GeekBrains - образовательный портал"},{"hid":"og:description","property":"og:description","content":"Мы учим людей с нуля осваивать программирование, веб-дизайн и маркетинг и другие профессии. Проводим онлайн-курсы и бесплатные мастер-классы, развиваем сообщество, сотрудничаем с компаниями по трудоустройству и непрерывно тестируем новые методики для поднятия эффективности обучения."},{"name":"og:type","content":"website"},{"name":"og:url","content":"https:\u002F\u002Fgb.ru\u002F"},{"name":"og:image","content":"https:\u002F\u002Fgb.ru\u002Fandroid-chrome-192x192.png"},{"name":"msapplication-TileColor","content":"#da532c"},{"name":"msapplication-TileImage","content":"\u002Fmstile-144x144.png"},{"name":"theme-color","content":"#ffffff"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"image_src","href":"https:\u002F\u002Fgb.ru\u002Fandroid-chrome-192x192.png"},{"hid":"link_canonical","rel":"canonical","href":"https:\u002F\u002Fgb.ru"},{"rel":"apple-touch-icon","sizes":"57x57","href":"\u002Fapple-touch-icon-57x57.png"},{"rel":"apple-touch-icon","sizes":"60x60","href":"\u002Fapple-touch-icon-60x60.png"},{"rel":"apple-touch-icon","sizes":"72x72","href":"\u002Fapple-touch-icon-72x72.png"},{"rel":"apple-touch-icon","sizes":"76x76","href":"\u002Fapple-touch-icon-76x76.png"},{"rel":"apple-touch-icon","sizes":"114x114","href":"\u002Fapple-touch-icon-114x114.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"\u002Fapple-touch-icon-120x120.png"},{"rel":"apple-touch-icon","sizes":"144x144","href":"\u002Fapple-touch-icon-144x144.png"},{"rel":"apple-touch-icon","sizes":"152x152","href":"\u002Fapple-touch-icon-152x152.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fapple-touch-icon-180x180.png"},{"rel":"icon","sizes":"16x16","type":"image\u002Fpng","href":"\u002Ffavicon-16x16.png"},{"rel":"icon","sizes":"32x32","type":"image\u002Fpng","href":"\u002Ffavicon-32x32.png"},{"rel":"icon","sizes":"96x96","type":"image\u002Fpng","href":"\u002Ffavicon-96x96.png"},{"rel":"icon","sizes":"192x192","type":"image\u002Fpng","href":"\u002Ffavicon-192x192.png"},{"rel":"icon","sizes":"192x192","type":"image\u002Fpng","href":"\u002Fandroid-chrome-192x192.png"},{"rel":"manifest","href":"\u002Fmanifest.json"},{"rel":"mask-icon","href":"\u002Fsafari-pinned-tab.svg","color":"#5bbad5"}],"script":[{"type":"application\u002Fld+json","json":{"@context":"http:\u002F\u002Fschema.org","@type":"EducationalOrganization","name":"GeekBrains","image":"https:\u002F\u002Ffrontend-scripts.hb.bizmrg.com\u002Fassets\u002Flogo\u002Fgeekbrains-logo-short.svg","telephone":"8 800 700-68-41","email":"mailto:support@geekbrains.ru","address":{"@type":"PostalAddress","addressLocality":"Москва, Россия","postalCode":"125167","streetAddress":"Ленинградский проспект, дом 39, строение 80, 16 этаж"}}},{"type":"application\u002Fld+json","json":{"@context":"http:\u002F\u002Fschema.org","@type":"WebSite","name":"GeekBrains","url":"https:\u002F\u002Fgb.ru\u002F","potentialAction":{"@type":"SearchAction","target":"https:\u002F\u002Fgb.ru\u002Fsearch?q={search_term_string}&organic=sitelinks_searchterm","query-input":"required name=search_term_string"}}},{"type":"application\u002Fld+json","json":{"@context":"http:\u002F\u002Fschema.org","@type":"QAPage","mainEntity":{"@type":"Question","dateCreated":"22.10.2025 14:29:32","name":"Онлайн-школа GeekBrains","text":"Выбирайте профессию, получите ИИ-booster и ещё 3 курса под вашу цель в подарок бесплатно","author":{"@type":"Person","name":"Антон Мойс"},"acceptedAnswer":{"@type":"Answer","author":{"@type":"Organization","name":" GeekBrains "},"text":"🔥Черная Пятница🔥  Скидки до 65% + 3 Курса в 🎁подарок"},"answerCount":1}}},{"type":"text\u002Fjavascript","src":"https:\u002F\u002Fgb.ru\u002Fchannels\u002Fassets\u002Fjs\u002FadvCake.js","id":"advcakeAsync"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-TZ45BH')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-TZ45BH&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_4755f2b4 === 'function') {
    await nuxt_plugin_plugin_4755f2b4(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_2998be80 === 'function') {
    await nuxt_plugin_sentryserver_2998be80(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_78416610 === 'function') {
    await nuxt_plugin_sentryclient_78416610(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_24584b2b === 'function') {
    await nuxt_plugin_recaptcha_24584b2b(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_22f7bb38 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_22f7bb38(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_c6507edc === 'function') {
    await nuxt_plugin_gtm_c6507edc(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_70c92348 === 'function') {
    await nuxt_plugin_moment_70c92348(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_28e77a02 === 'function') {
    await nuxt_plugin_pluginutils_28e77a02(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_20efe6ec === 'function') {
    await nuxt_plugin_pluginrouting_20efe6ec(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_483d3b25 === 'function') {
    await nuxt_plugin_pluginmain_483d3b25(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtplugintemplate70eaf4f2_7d491f3f === 'function') {
    await nuxt_plugin_nuxtplugintemplate70eaf4f2_7d491f3f(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_26ff7abc === 'function') {
    await nuxt_plugin_axios_26ff7abc(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_4bbe9647 === 'function') {
    await nuxt_plugin_deviceplugin_4bbe9647(app.context, inject)
  }

  if (typeof nuxt_plugin_repositories_3f2ec844 === 'function') {
    await nuxt_plugin_repositories_3f2ec844(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659cf26 === 'function') {
    await nuxt_plugin_axios_5659cf26(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_header_bb303ad4 === 'function') {
    await nuxt_plugin_header_bb303ad4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_axiosclient_978c8458 === 'function') {
    await nuxt_plugin_axiosclient_978c8458(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_6e5ad03a === 'function') {
    await nuxt_plugin_veevalidate_6e5ad03a(app.context, inject)
  }

  if (typeof nuxt_plugin_notification_f433b93e === 'function') {
    await nuxt_plugin_notification_f433b93e(app.context, inject)
  }

  if (typeof nuxt_plugin_focusoutside_1eaac9fa === 'function') {
    await nuxt_plugin_focusoutside_1eaac9fa(app.context, inject)
  }

  if (typeof nuxt_plugin_api_5e4622e4 === 'function') {
    await nuxt_plugin_api_5e4622e4(app.context, inject)
  }

  if (typeof nuxt_plugin_jwt_58cb8274 === 'function') {
    await nuxt_plugin_jwt_58cb8274(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_floatingvue_098517bc === 'function') {
    await nuxt_plugin_floatingvue_098517bc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_portalvue_cb5f1eca === 'function') {
    await nuxt_plugin_portalvue_cb5f1eca(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plyr_6a84fe8b === 'function') {
    await nuxt_plugin_plyr_6a84fe8b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_autoleadclient_10a070c2 === 'function') {
    await nuxt_plugin_autoleadclient_10a070c2(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_7a283218 === 'function') {
    await nuxt_plugin_auth_7a283218(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
